import { inject, Injectable } from '@angular/core';
import { GridOperatorService as CmsApiGridOperatorService } from '../../../core/cms-api/services';
import { map, Observable } from 'rxjs';
import {
  CreateGridOperatorRequest,
  GridOperatorDtoPagedResponseResult,
  GridOperatorDtoResult,
  RegionDto,
  Result,
} from '../../../core/cms-api/models';

@Injectable({
  providedIn: 'root',
})
export class GridOperatorsService {
  private apiService = inject(CmsApiGridOperatorService);

  getGridOperators(
    operatorId: string,
    pageIndex: number,
    pageSize: number
  ): Observable<GridOperatorDtoPagedResponseResult> {
    return this.apiService.gridOperatorGet({
      PageIndex: pageIndex,
      PageSize: pageSize,
      OperatorId: operatorId,
    });
  }

  updateGridOperator(
    gridOperatorId: string,
    createGridOperatorRequest: CreateGridOperatorRequest
  ): Observable<GridOperatorDtoResult> {
    return this.apiService
      .gridOperatorGridOperatorIdPut({
        gridOperatorId,
        body: createGridOperatorRequest,
      });
  }

  createGridOperator(
    createGridOperatorRequest: CreateGridOperatorRequest
  ): Observable<GridOperatorDtoResult> {
    return this.apiService
      .gridOperatorPost({ body: createGridOperatorRequest });
  }

  getRegions(): Observable<RegionDto[]> {
    return this.apiService.gridOperatorOptionsRegionsGet({}).pipe(
      map((res) => {
        if (res.isSuccess) {
          return res.value ?? [];
        }

        console.error(res.error?.errorMessage);
        return [];
      })
    );
  }

  deleteGridOperator(gridOperatorId: string): Observable<Result> {
    return this.apiService.gridOperatorGridOperatorIdDelete({ gridOperatorId });
  }
}
